import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Layout from "@/components/Layout";
import SalesLayout from "@/components/SalesLayout";
import Dashboard from "@/pages/Dashboard";
import Contacts from "@/pages/Contacts";
import Segments from "@/pages/Segments";
import Templates from "@/pages/Templates";
import Campaigns from "@/pages/Campaigns";
import Inbox from "@/pages/Inbox";
import Leads from "@/pages/Leads";
import QualifiedLeads from "@/pages/QualifiedLeads";
import AIAgent from "@/pages/AIAgent";
import KnowledgeBase from "@/pages/KnowledgeBase";
import WhatsAppSettings from "@/pages/WhatsAppSettings";
import Team from "@/pages/Team";
import FollowUps from "@/pages/FollowUps";
import SuperAdmin from "@/pages/SuperAdmin";
import SuperCompanyDetail from "@/pages/SuperCompanyDetail";
import MyProfile from "@/pages/MyProfile";
import SalesDashboard from "@/pages/SalesDashboard";
import LeadDetail from "@/pages/LeadDetail";
import LeadFinder from "@/pages/LeadFinder";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="p-8 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (roles && !roles.includes(user.role)) {
    const home = user.role === "super_admin" ? "/super-admin"
                : user.role === "sales_associate" ? "/sales" : "/dashboard";
    return <Navigate to={home} replace />;
  }
  return children;
}

function RoleHome() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  const home = user.role === "super_admin" ? "/super-admin"
              : user.role === "sales_associate" ? "/sales" : "/dashboard";
  return <Navigate to={home} replace />;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/" element={<RoleHome />} />

          {/* Super Admin */}
          <Route path="/super-admin" element={<Protected roles={["super_admin"]}><SuperAdmin /></Protected>} />
          <Route path="/super-admin/companies/:cid" element={<Protected roles={["super_admin"]}><SuperCompanyDetail /></Protected>} />

          {/* Sales Associate dedicated area */}
          <Route path="/sales" element={<Protected roles={["sales_associate"]}><SalesLayout /></Protected>}>
            <Route index element={<SalesDashboard />} />
            <Route path="inbox" element={<Inbox />} />
            <Route path="inbox/:convId" element={<Inbox />} />
            <Route path="leads" element={<Leads />} />
            <Route path="leads/:lid" element={<LeadDetail />} />
            <Route path="qualified" element={<QualifiedLeads />} />
            <Route path="follow-ups" element={<FollowUps />} />
            <Route path="profile" element={<MyProfile />} />
          </Route>

          {/* Company Admin area */}
          <Route path="/" element={<Protected roles={["company_admin"]}><Layout /></Protected>}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="segments" element={<Segments />} />
            <Route path="templates" element={<Templates />} />
            <Route path="campaigns" element={<Campaigns />} />
            <Route path="inbox" element={<Inbox />} />
            <Route path="inbox/:convId" element={<Inbox />} />
            <Route path="leads" element={<Leads />} />
            <Route path="leads/:lid" element={<LeadDetail />} />
            <Route path="qualified" element={<QualifiedLeads />} />
            <Route path="follow-ups" element={<FollowUps />} />
            <Route path="lead-finder" element={<LeadFinder />} />
            <Route path="ai-agent" element={<AIAgent />} />
            <Route path="knowledge" element={<KnowledgeBase />} />
            <Route path="whatsapp" element={<WhatsAppSettings />} />
            <Route path="team" element={<Team />} />
            <Route path="profile" element={<MyProfile />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
